import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'//引入axios
Vue.prototype.$axios = axios;//把axios挂载到vue上
import ElementUI from 'element-ui'
// 1.引入vue-router
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
// 引入字体样式
import "@/assets/font/font.css"
import Carousel3d from 'vue-carousel-3d';
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Carousel3d)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
